<div #svgContainer id="svgContainer" class="icon-container" aria-hidden="true"></div>
